<template>
  <div :class="containerClasses" ref="myContainer">
    <div v-if="!mode||mode===0" :class="textClasses">
        <v-speed-dial v-model="editableOptions" direction="left" absolute right open-on-hover class="menu-align mt-n4 mr-n3 py-2">
            <template v-slot:activator>
                <v-btn small v-model="editableOptions" color="black" dark fab title="alignment" class="mx-0">
                    <v-icon>{{aligmentIcons[alignment]}}</v-icon>
                </v-btn>
            </template>
            <v-btn fab dark x-small color="black" v-for="(icon,i) in aligmentIcons" :key="i" 
                class="mr-0"
                v-show="alignment!=i"
                @click="alignment=i">
                <v-icon>{{aligmentIcons[i]}}</v-icon>
            </v-btn>
        </v-speed-dial>
        <div ref="myText" class="editable" 
            :contenteditable="editing" 
            @blur="handleDone" 
            @focus="handleFocus"
            @focusout="handleFocusOut"
            @selectstart="handleStart"
            @mousedown.stop="handleDown"
            @keyup.delete.stop="handleDelete"
            @keyup.enter.stop="handleEnter"
            @keypress="handleKeyPress" 
            @paste="handlePaste"
            v-html="value">
        </div>
  </div>
  <div v-else-if="mode===1" ref="myCode" class="code"
      :contenteditable="editing" 
      @blur="handleDone" 
      @focus="handleFocus"
      @focusout="handleFocusOut"
      @selectstart="handleStart"
      @keydown.tab.prevent.stop="handleTab"
      @keyup.delete.stop="handleDelete"
      @keyup.enter.stop="handleEnter"
      @keypress="handleKeyPress" 
      @paste="handlePaste"
      v-text="value"></div>
      <pre v-if="mode===1" class="line-numbers">
        <span v-for="l in lineCount" :key="l"></span>
      </pre>
    <div v-if="showMenu" class="menu pa-1 pl-3 elevation-3" :style="menuStyle">
      <span v-if="showlinkUrl" class="text-no-wrap d-flex flex-no-wrap">
        <input style="width:128px" placeholder="Type the link here" class="px-1 caption" ref="inputUrl" v-model="linkUrl" @keyup.enter="wrap('a',{href:'//',title:'My link'})" />
        <v-btn color="white" small icon @click.stop="unwrap('a')" title="clear link" v-show="linkUrl && linkUrl.length > 1">
            <v-icon>mdi mdi-close</v-icon>
        </v-btn>
        <v-btn title="set link" color="white" small icon @click.stop="wrap('a',{href:'//',title:'My link'})" :disabled="!linkUrl || linkUrl.length <= 1">
            <v-icon>mdi mdi-link</v-icon>
        </v-btn>
      </span>
      <span v-else class="text-no-wrap d-flex flex-no-wrap">
        <v-btn class="mx-1" :color="tagExists.b?'light-green accent-3':'white'" small icon @click.stop="wrap('b',null,tagExists.b)">
            <v-icon>mdi-24px mdi-format-bold</v-icon>
        </v-btn>
        <v-btn class="mx-1" :color="tagExists.em?'light-green accent-3':'white'" small icon @click.stop="wrap('em',null,tagExists.em)">
            <v-icon>mdi-24px mdi-format-italic</v-icon>
        </v-btn>
        <v-btn class="mx-1" :color="tagExists.h1?'light-green accent-3':'white'" small icon @click.stop="wrap('h1',null,tagExists.h1)">
            <v-icon>mdi-24px mdi-format-header-1</v-icon>
        </v-btn>
        <v-btn class="mx-1" :color="tagExists.h2?'light-green accent-3':'white'" small icon @click.stop="wrap('h2',null,tagExists.h2)">
            <v-icon>mdi-24px mdi-format-header-2</v-icon>
        </v-btn>
        <v-btn class="mx-1" :color="tagExists.a?'light-green accent-3':'white'" small icon @click.stop="showUrl()">
            <v-icon>mdi-24px mdi mdi-link-plus</v-icon>
        </v-btn>
        <v-btn class="mx-1" :color="tagExists.code?'light-green accent-3':'white'" small icon @click.stop="wrap('code',null,tagExists.code)">
            <v-icon>mdi-24px mdi-code-tags</v-icon>
        </v-btn>
      </span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Editable',
    data: () => ({
        menuStyle: {
            left: '50px',
            right: '50px'
        },
        showMenu: false,
        busy: false,
        bound: false,
        selectedText: null,
        linkUrl: null,
        showlinkUrl: false,
        hitCount: 0,
        tagExists: {},
        editableOptions: false,
        alignment: 0,
        aligmentIcons: [
            'mdi-format-align-left',
            'mdi-format-align-center',
            'mdi-format-align-right',
            'mdi-format-align-justify'
        ],
        lineCount: 1
    }),
    props: {
        value: {
            type: String,
            default: ''
        },
        maxLength: {
            type: Number,
            default: 5000
        },
        mode: {
            type: Number,
            default: 0 //text=0 code=1
        },
        classes: {
            type: Array,
            default() {
                return []
            }
        },
        editing: {
            type: Boolean,
            default: false
        },
        deleteMe: {
            type: Function,
            default() {
                console.log('mom delete me!')
            }
        }
    },
    computed: {
        textClasses() {
            return {
                'text-container': this.editing,
                'text-left': this.alignment===0,
                'text-center': this.alignment===1,
                'text-right': this.alignment===2,
                'text-justify': this.alignment===3
            }
        },
        containerClasses() {
            return this.classes
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        if (this.$refs.myCode) {
            this.lineCount = this.calcLines(this.$refs.myCode)
        }
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        bind(){
            if (!this.editing) {
                return
            }

            let editable = this.$refs.myText
            if (editable) {
                editable.addEventListener('mouseup', this.handleSelection)
                console.log('bind.....')
                this.bound = true
            }
        },
        unbind(){
            let editable = this.$refs.myText
            if (editable) {
                editable.removeEventListener('mouseup', this.handleSelection)
                console.log('unbind.....')
                this.bound = false
            }
        },
        reset(){
            console.log('reset.....')
            this.unbind()
            this.showMenu = false
            this.selectedText = null
            this.savedSel = null
            this.showlinkUrl = false
            this.linkUrl = null
            this.hitCount = 0
            this.bind()
            if (this.$refs.myCode) {
                this.lineCount = this.calcLines(this.$refs.myCode)
            }
        },
        resetMenu(){
            console.log('reset menu.....')
            this.showMenu = false
            this.selectedText = null
            this.savedSel = null
            this.showlinkUrl = false
            this.linkUrl = null
        },
        handleScroll () {
            this.reset()
        },
        handleKeyPress(e) {
            console.log('handleKeyPress...')
            this.resetMenu()
            if (e.target.innerText.length >= this.maxLength) {
                console.log("Max chars for this section is " + this.maxLength)
                e.preventDefault()
                return;
            }
        },
        handlePaste(e) {
            let clipboardData = e.clipboardData || window.clipboardData
            let pastedData = clipboardData.getData('Text')
            if (pastedData.length > this.maxLength) {
                console.log("Max chars for this section is " + this.maxLength)
                e.preventDefault()
            }
        },
        handleDelete(e) {
            console.log('delete', e.target.innerText, e.target.innerHTML.length)
            let nothingLeft = (e.target.innerText.length === 0 && e.target.innerHTML.length <= 4)

            if (nothingLeft && this.hitCount > 2) {
                console.log('nothingLeft delete!') 
                this.deleteMe(this.$vnode.key)
                this.hitCount = 0
                return;
            }
            else if (nothingLeft) {
                console.log('nothingLeft hitCount', this.hitCount) 
                this.hitCount = this.hitCount + 1
                setTimeout(()=>{
                    this.hitCount = 0
                }, 3500)
            }

            if (this.$refs.myCode) {
                this.lineCount = this.calcLines(this.$refs.myCode)
            }
        },
        handleTab() {
            //tab=&#009
            // insert 3 spaces
            document.execCommand('insertHTML', false, '&#032&#032&#032')
        },
        insertTextAtCursor(text) {
            //console.log('insertTextAtCursor');
            var sel, range;
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    range.insertNode( document.createTextNode(text) );
                }
            } else if (document.selection && document.selection.createRange) {
                document.selection.createRange().text = text;
            }
        },
        calcLines(el) {
            var styles = window.getComputedStyle(el, null);
            var divHeight = parseInt(styles.getPropertyValue("height"));
            var lineHeight = parseInt(styles.getPropertyValue('line-height'));
            //console.log(divHeight, lineHeight);
            var lines = parseInt(divHeight / lineHeight);
            return lines;
        },
        handleEnter(){
            console.log('handleEnter')
            if (this.$refs.myText) {
                //
            }
            else if (this.$refs.myCode) {
                this.lineCount = this.calcLines(this.$refs.myCode)
            }
        },
        handleDone(e) {
            if (this.selectedText && this.selectedText.length>0) {
                // if there's currently a selection
                // don't update the model!
                return
            }
            console.log('handleDone blur (update model)...',e)
            if (this.mode === 0) {
                this.$emit('input', e.target.innerHTML)
            } else {
                this.$emit('input', e.target.innerText)
            }
            this.reset()
        },
        handleFocus(e) {
            console.log('focus:' + this.$vnode.key)
            if (e.relatedTarget && (e.relatedTarget.tagName !== 'BUTTON' && e.relatedTarget.tagName !== 'INPUT')) {
                this.resetMenu()
            }
            this.classes.push('active')
        },
        handleFocusOut(e) {
            console.log('focusout:' + this.$vnode.key)
            if (e.relatedTarget && (e.relatedTarget.tagName !== 'BUTTON' && e.relatedTarget.tagName !== 'INPUT')) {
                this.resetMenu()
            }
            this.classes.pop()
        },
        handleDown() {
            console.log('down')
            this.resetMenu()
            if (this.mode === 0 && !this.bound) {
                this.bind()
            }
        },
        handleStart() {
            console.log('start')
            if (this.mode === 0 && !this.bound) {
                this.bind()
            }
        },
        replaceSelection(html, selectInserted) {
            var sel, range, fragment;
            
            if (typeof window.getSelection !== "undefined") {
                // IE 9 and other non-IE browsers
                sel = window.getSelection();
                
                // Test that the Selection object contains at least one Range
                if (sel.getRangeAt && sel.rangeCount) {
                    // Get the first Range (only Firefox supports more than one)
                    range = sel.getRangeAt(0);
                    range.deleteContents();
        
                    // Create a DocumentFragment to insert and populate it with HTML
                    // Need to test for the existence of range.createContextualFragment
                    // because it's non-standard and IE 9 does not support it
                    if (range.createContextualFragment) {
                        fragment = range.createContextualFragment(html);
                    } else {
                        // In IE 9 we need to use innerHTML of a temporary element
                        var div = document.createElement("div"), child;
                        div.innerHTML = html;
                        fragment = document.createDocumentFragment();
                        while ( (child = div.firstChild) ) {
                            fragment.appendChild(child);
                        }
                    }
                    var firstInsertedNode = fragment.firstChild;
                    var lastInsertedNode = fragment.lastChild;
                    range.insertNode(fragment);
                    if (selectInserted) {
                        if (firstInsertedNode) {
                            range.setStartBefore(firstInsertedNode);
                            range.setEndAfter(lastInsertedNode);
                        }
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
            } else if (document.selection && document.selection.type != "Control") {
                // IE 8 and below
                range = document.selection.createRange();
                range.pasteHTML(html);
            }
        },
        handleSelection() {
            //console.log('e:',e.target)
            //console.log('up:' + this.$vnode.key)
            let sel = window.getSelection()
            let selection = window.getSelection().anchorNode.textContent.substring(
                window.getSelection().extentOffset, 
                window.getSelection().anchorOffset
            )
            if (selection.length < 1) {
                //console.log('empty selection return')
                return
            }
            this.savedSel = this.saveSelection()
            //console.log('saved:',window.getSelection())
                
            if (sel.rangeCount) {
                let range = sel.getRangeAt(0);
                
                if (range.getClientRects) {
                    //range.collapse(true);
                    if (range.getClientRects().length>0){
                        console.log('getClientRects')
                        let rect = range.getClientRects()[0];
                        let x = rect.left;
                        let y = rect.top;
                        this.showMenu = false;
                        this.showlinkUrl = false;
                        setTimeout(()=>{
                            this.menuStyle = {
                                left: (x + (rect.width * 0.5)) + 'px',
                                top: (y - 45) + 'px'
                            }
                            this.showMenu = true
                        }, 200)
                    }

                    // detect existing tags
                    var n = window.getSelection().anchorNode.parentElement
                    var els = [];
                    var tags = [];
                    while (n) {
                        tags.push(n.tagName)
                        
                        if (n.classList && n.classList.toString().indexOf('editable')) {
                            els.unshift(n)
                            n = n.parentNode
                            tags.push(n.tagName)
                            break
                        }
                        
                        els.unshift(n)
                        n = n.parentNode;
                    }
                    
                    this.tagExists = {}  
                    for (var t in tags) {
                        //console.log(tags[t])
                        let tagName = tags[t].toLowerCase()
                        this.tagExists[tagName] = true
                        if (tagName==='a') {
                            let href = window.getSelection().anchorNode.parentElement.getAttribute('href')
                            this.linkUrl = href!=='null'?href:''
                        }
                    }
                    //console.log(this.tagExists)
                }
            }
            
            this.selectedText = selection
        },
        triggerUpdate(){
            console.log('triggerUpdate...')
            //triggers input event to force model update
            var event = new Event('input', {
                bubbles: true,
                cancelable: false,
                data: '',
                inputType: 'insertText',
                isTrusted: true,
                type: 'input',
                target: this.$refs.myText
            });
            
            this.$refs.myText.dispatchEvent(event);
        },
        showUrl() {
            this.showlinkUrl = true
            console.log('this.$refs.inputUrl:',this.$refs)
            setTimeout(()=>{
                this.$refs.inputUrl.focus()  
            }, 300)
        },
        saveSelection() {
            if (window.getSelection) {
                let sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    return sel.getRangeAt(0);
                }
            } else if (document.selection && document.selection.createRange) {
                return document.selection.createRange();
            }
            return null;
        },
        restoreSelection(range) {
            //console.log('restoreSelection:',range)
            if (range) {
                if (window.getSelection) {
                    let sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);

                } else if (document.selection && range.select) {
                    range.select();
                }
            }
        },
        unwrap(tagName) {
            
            //console.log('unwrap...',tagName,this.selectedText)
            this.restoreSelection(this.savedSel)
            
            let sel = window.getSelection();
            let wrapper = sel.anchorNode.parentNode;
            
            if (wrapper.tagName.toLowerCase() !== tagName) {
                //console.log('wrong parent:',wrapper.tagName)
                wrapper = wrapper.parentNode;

                //no don't unwrap the root text container!
                if (wrapper.classList.contains('text-container')) {
                    this.resetMenu()
                    return
                }
            }

            var docFrag = document.createDocumentFragment();
            while (wrapper.firstChild) {
                var child = wrapper.removeChild(wrapper.firstChild);
                docFrag.appendChild(child);
            }

            this.reset()
            this.selectedText = null
            this.$refs.myText.addEventListener('input', this.handleDone)
            
            // replace wrapper with document fragment
            wrapper.parentNode.replaceChild(docFrag, wrapper)
            this.triggerUpdate()
            
            setTimeout(()=>{
                this.$refs.myText.removeEventListener('input', this.handleDone)
                this.reset()
            }, 300)
            
        },
        wrap(tag,attrs,unwrap) {
            if (unwrap) {
                this.unwrap(tag)
                return
            }
            this.restoreSelection(this.savedSel)
            let sel = window.getSelection();
            //console.log('from saved:',sel)
            let selection = sel.anchorNode.textContent.substring(
                sel.extentOffset,
                sel.anchorOffset
            )
            //console.log('selection:',selection)
            //console.log('selectedText:',selectedText)
            if (selection.length>0) {
                this.unbind()
                this.selectedText = null
                this.$refs.myText.addEventListener('input', this.handleDone)
                
                //insert as node
                /*
                let newNode = document.createElement(tag);
                newNode.innerText = selection;
                if (attrs) {
                    let keys = Object.keys(attrs)
                    for (var k in keys) {
                        //console.log('keys:',k)
                        newNode[keys[k]] = attrs[keys[k]]
                    }
                }*/
                
                let parentEl = sel.getRangeAt(0).commonAncestorContainer;
                if (!sel.containsNode(parentEl, false)) {
                    /* get inner HTML since the selection spans another tag */
                    let range = sel.getRangeAt(0);
                    var clonedSelection = range.cloneContents();
                    var div = document.createElement('div');
                    div.appendChild(clonedSelection);
                    //console.log(div.innerHTML);
                    selection = div.innerHTML
                }

                let startTag = '<'+tag+'>'
                if (tag === 'a') {
                    startTag = '<'+tag+' title="' + this.linkUrl + '" href="' + this.linkUrl + '">'
                }

                this.replaceSelection(startTag + '' + selection + '</'+tag+'>',false)
                this.triggerUpdate()
                setTimeout(()=>{
                    this.$refs.myText.removeEventListener('input', this.handleDone)
                    this.reset()
                }, 100)
            }
        }
    },
    watch: {
        editing() {
            this.reset()
        }
    }
}
</script>
